import { Dialog, DialogContent, IconButton, Grid, TextField, InputAdornment, Tab, Tabs, Box, Button, CircularProgress, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FieldSelect } from "../../../components/selections/fieldInputs";
import FilterMultiSelect from "../../../components/selections/filterMultiSelect";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import { QR, qrDialogPaperSx, QrModalHeader } from "../../qrCode/components/qrUi";
import { stepActionsSx, backBtnSx, nextBtnSx } from "../../campaign/components/stepUi";
import { EmpLabel, empInputSx } from "./employeeUi";
import { APP_ROUTES } from "../../../config/appRoutes";
import { getEmployeeThunk, updateEmployeeThunk } from "../employeeThunk";
import Slide from '@mui/material/Slide';
import React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function EmployeeEditModal({ show, handleClose, rowData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { branches, departments, branchDepartments } = useSelector((state) => state.general);
    const { employeeLevels, employeeModules, status1 } = useSelector((state) => state.employees);
    const [changedFields, setChangedFields] = useState(new Set());

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });


    const [tabValue, setTabValue] = useState(1);
    const [state, setState] = useState({
        employeeType: 1,
        selectedDepartment: [],
        selectedBranch: [],
        selectBranchDepartments: [],
        employeeName: "",
        userName: "",
        empPassword: "",
        empEmailAdd: "",
        empContact: "",
        selectedModules: [],
        errors: {},
        showPassword: false,
    });

    const { employeeType, selectedDepartment, selectedBranch, selectBranchDepartments, employeeName, userName, empPassword, empEmailAdd, empContact, selectedModules, showPassword } = state;
    const matchedBrachDept = branchDepartments.filter((item) => +rowData?.branch_department_id?.includes(+item.id)).map((item) => ({ value: item.id, label: item.branch_department_name }));

    useEffect(() => {
        if (rowData && rowData !== undefined) {
            setState((prev) => ({
                ...prev,
                employeeType: rowData.employee_type_id || 1,
                employeeName: rowData.employee_name || "",
                userName: rowData.username || "",
                empPassword: "", // usually password won't come from API
                empEmailAdd: rowData.emp_email || "",
                empContact: rowData.emp_mobile || "",

                // Branch mapping: "14,246" with "kondaa,Kondapur"
                selectedBranch: rowData.branch_id
                    ? rowData.branch_id.split(",").map((id, idx) => ({
                        value: Number(id),
                        label: rowData.branch_name?.split(",")[idx] || "",
                    }))
                    : [],

                // Department mapping
                selectedDepartment: rowData.department_id
                    ? rowData.department_id.split(",").map((id, idx) => ({
                        value: Number(id),
                        label: rowData.department_name?.split(",")[idx] || "",
                    }))
                    : [],

                // Branch department mapping
                selectBranchDepartments: rowData.branch_department_id
                    ? matchedBrachDept
                    : [],

                // Module mapping from object → array
                selectedModules: rowData?.module_access
                    ? Object.entries(rowData.module_access)
                        .filter(([key, value]) => value) // take only keys with true
                        .map(([key]) => {
                            const mod = employeeModules.find(
                                (m) => m.display_name.toLowerCase() === key.toLowerCase()
                            );
                            return mod
                                ? { value: mod.id, label: mod.display_name, access_name: mod.name }
                                : { value: key, label: key, access_name: key };
                        })
                    : []
            }));
        } else {
            setState({
                employeeType: 1,
                selectedDepartment: [],
                selectedBranch: [],
                selectBranchDepartments: [],
                employeeName: "",
                userName: "",
                empPassword: "",
                empEmailAdd: "",
                empContact: "",
                selectedModules: [],
                errors: {},
                showPassword: false,
            })
        }
        setTabValue(0);
        setChangedFields(new Set());
    }, [rowData, employeeModules, branchDepartments]);

    const addEmpFileds = [
        { id: 1, value: employeeType, type: "select", options: employeeLevels.map((item) => ({ value: item.id, label: item.user_level })), label: "Employee type", name: "employeeType" },
        { id: 2, value: selectedDepartment, type: "multi-select", options: departments.map((item) => ({ value: item.id, label: item.department_name })), label: "Select Department", name: "selectedDepartment" },
        { id: 3, value: selectedBranch, type: "multi-select", options: branches.map((item) => ({ value: item.id, label: item.branch_name })), label: "Select Branch", name: "selectedBranch" },
        { id: 4, value: selectBranchDepartments, type: "multi-select", options: branchDepartments.map((item) => ({ value: item.id, label: item.branch_department_name })), label: "Select Branch Departments", name: "selectBranchDepartments" },
        { id: 5, value: employeeName, type: "text", label: "Name", name: "employeeName" },
        { id: 6, value: userName, type: "text", label: "User Name", name: "userName" },
        { id: 7, value: empEmailAdd, type: "email", label: "Email", name: "empEmailAdd" },
        { id: 8, value: empContact, type: "text", label: "Mobile Number", name: "empContact" },
        { id: 9, value: selectedModules, type: "multi-select", options: employeeModules.map((item) => ({ value: item.id, label: item.display_name, access_name: item.name })), label: "Select Modules", name: "selectedModules" },
    ];

    const handleChange = (name, value) => {
        let newValue = value; 

        if (name === "empContact") {
            newValue = value.replace(/\D/g, "").slice(0, 10);
        } else if (name === "userName") {
            newValue = value.slice(0, 20);
        } else if (name === "empEmailAdd") {
            // Remove spaces, allow max 100 chars, preserve cursor position
            const cleaned = value.replace(/\s/g, "");
            if (cleaned.length <= 100 || cleaned.length < state.empEmailAdd.length) {
                newValue = cleaned;
            } else {
                // If trying to add more than 100, ignore the change
                return;
            }
        } else if (name === "employeeName") {
            newValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ").slice(0, 50);
        }

        setState((prev) => ({
            ...prev,
            [name]: newValue,
            errors: { ...prev.errors, [name]: "" },
        }));
        setChangedFields((prev) => new Set(prev).add(name));
    };

    const handleMultiSelectChange = (name, selectedValues) => {
        setState((prev) => ({
            ...prev,
            [name]: selectedValues,
            errors: { ...prev.errors, [name]: "" },
        }));
        setChangedFields((prev) => new Set(prev).add(name));
    };

    const handleSingleSelectChange = (name, selectedValue) => {
        setState((prev) => ({
            ...prev,
            [name]: selectedValue,
            errors: { ...prev.errors, [name]: "" },
        }));
        setChangedFields((prev) => new Set(prev).add(name));
    };

    const handleClickShowPassword = () => {
        setState((prevState) => ({
            ...prevState,
            showPassword: !prevState.showPassword,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validations = [
            { valid: !!employeeType, message: "Employee type is required", field: "employeeType" },

            ...(employeeType === 2
                ? [{ valid: selectedDepartment.length > 0, message: "Select at least one department", field: "selectedDepartment" }]
                : []),

            ...(employeeType === 3
                ? [{ valid: selectedBranch.length > 0, message: "Select at least one branch", field: "selectedBranch" }]
                : []),

            ...(employeeType === 4
                ? [{ valid: selectBranchDepartments.length > 0, message: "Select branch departments", field: "selectBranchDepartments" }]
                : []),

            { valid: !!employeeName, message: "Name is required", field: "employeeName" },
            { valid: !!userName, message: "User Name is required", field: "userName" },

            ...(tabValue === 0
                ? [
                    { valid: !!empEmailAdd, message: "Email is required", field: "empEmailAdd" },
                    { valid: !/\s/.test(empEmailAdd), message: "Email cannot contain spaces", field: "empEmailAdd" },
                    { valid: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(empEmailAdd.replace(/\s/g, "")), message: "Enter a valid email address", field: "empEmailAdd" },
                    { valid: !!empContact, message: "Mobile number is required", field: "empContact" },
                    { valid: /^[6-9]\d{9}$/.test(empContact), message: "Enter a valid 10-digit mobile number", field: "empContact" },
                ]
                : tabValue === 1
                    ? [
                        { valid: !!empPassword, message: "Password is required", field: "empPassword" },
                        { valid: empPassword?.length >= 6 && empPassword?.length <= 16, message: "Password must be 6–16 characters", field: "empPassword" },
                    ]
                    : []
            ),

            { valid: selectedModules.length > 0, message: "Select at least one module", field: "selectedModules" },
        ];


        for (let rule of validations) {
            if (!rule.valid) {
                setSnackbar({
                    open: true,
                    message: rule.message,
                    severity: "error",
                });

                setState((prev) => ({
                    ...prev,
                    errors: { ...prev.errors, [rule.field]: rule.message },
                }));
                return;
            }
        }

        if (!changedFields || changedFields.size === 0) {
            setSnackbar({
                open: true,
                message: "No changes to update",
                severity: "info",
            });
            setTimeout(() => {
                handleClose();
            }, 1000);
            return;
        } else {

            const payload = {};

            if (changedFields.has("employeeName")) {
                payload.employee_name = employeeName;
            }

            if (changedFields.has("empContact")) {
                payload.emp_mobile = empContact;
            }

            if (changedFields.has("empEmailAdd")) {
                payload.emp_email = empEmailAdd;
            }

            if (changedFields.has("userName")) {
                payload.username = userName;
            }

            if (changedFields.has("empPassword")) {
                payload.password = empPassword;
            }

            if (changedFields.has("employeeType")) {
                payload.employee_type_id = employeeType;
            }

            if (changedFields.has("selectedDepartment")) {
                payload.department_id =
                    selectedDepartment.length > 0
                        ? selectedDepartment.map((item) => item.value).toString()
                        : "";
            }

            if (changedFields.has("selectedBranch")) {
                payload.branch_id =
                    selectedBranch.length > 0
                        ? selectedBranch.map((item) => item.value).toString()
                        : "";
            }

            if (changedFields.has("selectBranchDepartments")) {
                payload.branch_department_id =
                    selectBranchDepartments.length > 0
                        ? selectBranchDepartments.map((item) => item.value).toString()
                        : "";
            }

            if (changedFields.has("selectedModules")) {
                payload.module_access =
                    selectedModules.length > 0
                        ? selectedModules.reduce((acc, item) => {
                            acc[item.access_name] = true;
                            return acc;
                        }, {})
                        : {};
            }

            const payload1 = {
                ...payload,
                "id": rowData?.id
            };
     
            try {
                const result = await dispatch(updateEmployeeThunk({ credentials: payload1 }));

                if (result.meta.requestStatus === "fulfilled") {
                    setSnackbar({
                        open: true,
                        message: result.payload.message,
                        severity: "success",
                    });

                    await dispatch(getEmployeeThunk({ type: "getEmpData" }));
                    navigate(APP_ROUTES.EMPLOYEE.LIST);
                    handleClose();
                } else {
                    setSnackbar({
                        open: true,
                        message: result.payload,
                        severity: "error",
                    });
                }
            } catch {
                setSnackbar({
                    open: true,
                    message: "Server error. Please try again.",
                    severity: "error",
                });
            }
        }
    }


    useEffect(() => {
        if (!show) {
            setState({
                employeeType: 1,
                selectedDepartment: [],
                selectedBranch: [],
                selectBranchDepartments: [],
                employeeName: "",
                userName: "",
                empPassword: "",
                empEmailAdd: "",
                empContact: "",
                selectedModules: [],
                errors: {},
                showPassword: false,
            })
            setTabValue(0);
            setChangedFields(new Set());
        }
    }, [show])


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setState(prev => ({ ...prev, errors: {} }))
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="md"
            keepMounted
            PaperProps={{ sx: qrDialogPaperSx }}
        >
            <QrModalHeader
                icon={<ManageAccountsIcon />}
                title="Edit Employee"
                subtitle={rowData?.employee_name || rowData?.username || "Update details or reset the password"}
                onClose={() => handleClose()}
            />

            <DialogContent sx={{ p: { xs: 2, sm: 3 }, pt: { xs: 2, sm: 2.5 } }}>

                <Box sx={{ mb: 3 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        aria-label="basic tabs example"
                        variant="fullWidth"
                        TabIndicatorProps={{ style: { display: "none" } }}
                        sx={{
                            minHeight: 0,
                            p: 0.5,
                            borderRadius: 3,
                            bgcolor: "#f1f5f9",
                            maxWidth: { sm: 420 },
                            "& .MuiTab-root": {
                                minHeight: 38,
                                minWidth: 0,
                                py: 0.75,
                                px: { xs: 1, sm: 2 },
                                borderRadius: 2.5,
                                textTransform: "none",
                                fontSize: { xs: 12.5, sm: 13.5 },
                                fontWeight: 700,
                                color: "#64748b",
                                transition: "all .15s ease",
                            },
                            "& .MuiTab-root.Mui-selected": {
                                color: QR.blue,
                                bgcolor: "#fff",
                                boxShadow: "0 1px 3px rgba(16,24,40,0.12)",
                            },
                        }}
                    >
                        <Tab icon={<BadgeOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Update Details" {...a11yProps(0)} />
                        <Tab icon={<KeyOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Update Password" {...a11yProps(1)} />
                    </Tabs>
                </Box>

                <Grid container spacing={2.5}>
                    {
                        tabValue === 0 ? (
                            <>
                                {addEmpFileds.map((field) => {
                                    if (employeeType !== null) {
                                        if (field.name === "selectedDepartment" && employeeType !== 2) return null;
                                        if (field.name === "selectedBranch" && employeeType !== 3) return null;
                                        if (field.name === "selectBranchDepartments" && employeeType !== 4) return null;

                                        if (
                                            employeeType === 1 &&
                                            ["selectedDepartment", "selectedBranch", "selectBranchDepartments"].includes(field.name)
                                        ) {
                                            return null;
                                        }
                                    }
                                    return (
                                        <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={field.id}>
                                            {field.type === "text" || field.type === "email" || field.type === "number" ? (
                                                <Box>
                                                    <EmpLabel label={field.label} />
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        type={field.type}
                                                        value={field.value}
                                                        onChange={(e) => handleChange(field.name, e.target.value)}
                                                        error={!!state.errors[field.name]}
                                                        disabled={field.id === 6}
                                                        sx={empInputSx}
                                                        {...(field.id === 8
                                                            ? { inputProps: { inputMode: "numeric", pattern: "[0-9]*" } }
                                                            : {})}
                                                        onKeyDown={field.name === "empEmailAdd" ? (e) => {
                                                            if (e.key === " " || e.key === "Spacebar") {
                                                                e.preventDefault();
                                                            }
                                                        } : undefined}
                                                    />
                                                </Box>
                                            ) : field.type === "select" ? (
                                                // read-only look, same as the disabled User Name field
                                                <Box
                                                    sx={{
                                                        "& .MuiOutlinedInput-root, & .MuiOutlinedInput-root.Mui-disabled": { bgcolor: "#f8fafc !important" },
                                                        "& .MuiAutocomplete-endAdornment": { display: "none" },
                                                        "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "rgba(0,0,0,0.38)", cursor: "not-allowed" },
                                                        "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": { borderColor: "#e5e7eb" },
                                                    }}
                                                >
                                                    <FieldSelect
                                                        name={field.name}
                                                        label={field.label}
                                                        options={field.options}
                                                        value={field.value}
                                                        onChange={handleSingleSelectChange}
                                                        error={!!state.errors[field.name]}
                                                        disabled
                                                    />
                                                </Box>
                                            ) : field.type === "multi-select" ? (
                                                <FilterMultiSelect
                                                    name={field.name}
                                                    label={field.label}
                                                    options={field.options}
                                                    value={state[field.name] || []}
                                                    onChange={handleMultiSelectChange}
                                                    formHelperText={false}
                                                    error={!!state.errors[field.name]}
                                                />
                                            ) : null}
                                        </Grid>
                                    )
                                })}
                            </>

                        ) : (
                            <Grid item size={{ xs: 12, sm: 6 }}>
                                <EmpLabel label="Password" />
                                <TextField
                                    fullWidth
                                    size="small"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="6–16 characters"
                                    value={empPassword}
                                    onChange={(e) => handleChange("empPassword", e.target.value)}
                                    error={!!state.errors.empPassword}
                                    sx={empInputSx}
                                    inputProps={{ minLength: 6, maxLength: 16 }}
                                    onKeyDown={(e) => {
                                        if (e.key === " " || e.key === "Spacebar") {
                                            e.preventDefault();
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleClickShowPassword} size="small" sx={{ cursor: "pointer" }}>
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        )
                    }
                </Grid>
            </DialogContent>

            <Box sx={{ ...stepActionsSx, px: { xs: 2, sm: 3 }, py: 1.75, bgcolor: "#fafbfc" }}>
                <Stack direction="row" spacing={1.5}>
                    <Button onClick={() => handleClose()} sx={backBtnSx}>
                        Cancel
                    </Button>
                    <Button
                        onClick={status1 === "loading" ? null : handleSubmit}
                        disabled={status1 === "loading"}
                        startIcon={status1 === "loading" ? <CircularProgress size={15} sx={{ color: "#fff" }} /> : <SaveOutlinedIcon />}
                        sx={nextBtnSx}
                    >
                        {status1 === "loading" ? "Submitting.." : "Update Employee"}
                    </Button>
                </Stack>
            </Box>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Dialog>
    );
}
